module.exports = __webpack_public_path__ + "img/petronas_towers.3d722b19.jpg";